





























































































import Vue from "vue";
import Component from "vue-class-component";
import { GroupedByProductGroup, ProductInOverview } from "@/models/queries/ProductOverviewQuery";
import { NewProductStore } from "@/store/NewProductStore";
import * as _ from "lodash";
import ProductsGroupedByGroup from "@/components/products/partials/overview/products-grouped-by-group.vue";
import { isDevOrLocalEnvironment } from "@/utils/environment";

@Component({
  components: { ProductsGroupedByGroup }
})
export default class ProductsIndex extends Vue {
  private selectedProduct: ProductInOverview | null = null;
  private deletedProducts: ProductInOverview[] = [];

  private mounted() {
    NewProductStore.fetchOverview();
  }

  get products(): Map<string, GroupedByProductGroup> {
    const sorted = _.sortBy(
      NewProductStore.products,
      "customer",
      "productGroup.name",
      "screwType",
      "head",
      "recessType",
      "screwDiameter",
      "screwLength",
      "threadType",
      "surfaceColor"
    );

    const map = new Map<string, GroupedByProductGroup>();
    sorted.forEach(product => {
      const entry = map.get(product.productGroup.id) || {
        productGroup: product.productGroup,
        products: []
      };
      entry.products.push(product);
      map.set(product.productGroup.id, entry);
    });

    return map;
  }

  get fetching() {
    return NewProductStore.loading;
  }

  get hasError() {
    return NewProductStore.hasError;
  }

  get isDevOrLocalEnv() {
    return isDevOrLocalEnvironment();
  }
}
